import PropTypes from 'prop-types'
import { Suspense, useState } from 'react'
import { ImSpinner9 } from 'react-icons/im'
import Navbar from './Navbar/Navbar'
import Sidebar from './Sidebar/Sidebar'

const COLLAPSED_KEY = 'sidebarCollapsed'

const readCollapsed = () => {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === '1'
  } catch {
    return false
  }
}

export default function Layout({ children }) {
  // Escritorio: menú plegado a solo iconos (se recuerda entre visitas)
  const [collapsed, setCollapsedState] = useState(readCollapsed)
  // Móvil: menú abierto como panel superpuesto
  const [mobileOpen, setMobileOpen] = useState(false)

  const setCollapsed = (value) => {
    setCollapsedState(value)
    try { localStorage.setItem(COLLAPSED_KEY, value ? '1' : '0') } catch { /* sin storage */ }
  }

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-slate-50 text-gray-900">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <div className="flex min-w-0 flex-1 flex-col">
        <Navbar onOpenMobileMenu={() => setMobileOpen(true)} />

        <main
          id="scrollable-parent"
          className="relative flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-8"
        >
          {/* Las páginas se cargan bajo demanda: mientras llega su fichero,
              la barra superior y el menú siguen visibles */}
          <Suspense
            fallback={
              <div className="flex items-center justify-center py-24 text-gray-400">
                <ImSpinner9 size={32} className="animate-spin" />
              </div>
            }
          >
            <div className="mx-auto w-full max-w-[1400px]">
              {children}
            </div>
          </Suspense>
        </main>
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}
